<template>
  <div class="content-course">
    <router-link
      class="content-course__tile"
      :to="
        $buildContentLink('course', {
          id: course.uuid,
          slug: course.slug,
          learning_areas: [{ name: learningAreaName }],
        })
      "
      :style="`background: linear-gradient(${$getGradient()})`"
    >
      <img
        class="content-course__tile--img"
        :src="`${$getCourseBackground(course.uuid, 'small')}`"
        onerror="this.style.display='none'"
        alt="Course background"
      />
      <img
        src="@/assets/icons/course/course_icon.png"
        class="content-course__tile--icon"
        alt="Computer terminal icon"
      />
    </router-link>
    <div class="content-course__details">
      <p class="content-course__details--title">
        <router-link
          class="content-course__name"
          :to="
            $buildContentLink('course', {
              id: course.uuid,
              slug: course.slug,
              learning_areas: [{ name: learningAreaName }],
            })
          "
        >
          {{ course.name }}
        </router-link>
        <span
          v-if="course.optional === 1"
          class="content-course__details--optional"
          >Optional</span
        >
        <span
          v-if="course.status === 'coming soon'"
          class="content-course__details--coming-soon"
        >
          Coming Soon
        </span>
      </p>
      <p class="lead">
        Instructor:
        <span class="data">{{ course.instructors[0].name }}</span>
      </p>
      <p class="lead">
        Course Duration:
        <span class="data content-course__details--duration">{{
          $duration.durationFromSecs(course.duration_in_seconds)
        }}</span>
      </p>
    </div>
    <div class="content-course__btn-wrapper">
      <router-link
        v-if="isAuthenticated"
        class="btn btn--secondary"
        :to="
          $buildContentLink('course', {
            id: course.uuid,
            slug: course.slug,
            learning_areas: [{ name: learningAreaName }],
          })
        "
      >
        {{ buttonText }}
      </router-link>
      <template v-else>
        <a class="btn btn--secondary" :href="`//${plansLink}`">
          <LockIcon />
          {{ isComingSoon ? 'Coming soon' : 'Get access' }}
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import LockIcon from '@/assets/icons/fill/lock.svg'

export default {
  name: 'Course',
  components: {
    LockIcon: { ...LockIcon, name: 'LockIcon' },
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
  },
  computed: {
    buttonText() {
      const { user_status } = this.course
      if (user_status) {
        const { progress } = user_status
        if (progress === 1) {
          return 'Replay'
        }
        if (progress > 0) {
          return 'Resume'
        }
      }
      return 'Begin'
    },
    isComingSoon() {
      const { status } = this.course
      return status && status.length && status === 'coming soon'
    },
  },
}
</script>

<style lang="scss" scoped>
.content-course {
  width: 100%;
  min-width: 100%;
  display: flex;
  flex-wrap: wrap;
  @include tablet {
    flex-wrap: nowrap;
  }
  &__tile {
    margin: 0 auto 0 0;
    height: 120px;
    width: 200px;
    position: relative;
    @include tablet {
      margin: 0 0 0 50px;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    &--img {
      height: 120px;
      width: 100%;
    }
    &--icon {
      position: absolute;
      font-size: 2.5rem;
      left: 20px;
      top: 40px;
      color: var(--white);
    }
  }
  &__name {
    color: var(--white);
  }
  &__details {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 0 10px;
    margin: 0 auto 0 0;
    @include mobile {
      padding: 0 0 0 50px;
    }
    @include desktop {
      padding: 0 0 0 75px;
    }
    &--title {
      font-size: 1.3rem;
      color: var(--white);
      margin: 0 0 20px 0;
      font-family: var(--font-bold);
    }
    &--optional {
      text-transform: uppercase;
      color: var(--orange);
      margin-left: 10px;
      padding-left: 10px;
      border-left: 1px solid var(--gray);
      font-size: 0.8rem;
    }
    &--coming-soon {
      text-transform: uppercase;
      color: var(--orange);
      margin-left: 10px;
      padding-left: 10px;
      border-left: 1px solid var(--gray);
      font-size: 0.8rem;
    }
    &--duration {
      text-transform: lowercase;
    }
  }
  &__btn-wrapper {
    margin: auto 0 0 auto;
  }
}
</style>
